import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: () =>
            import ('../views/Login.vue')
    },
    {
        path: '/selprolist',
        name: 'SelProList',
        component: () =>
            import ('../views/kqlog/SelProList.vue')
    },
    {
        path: '/selteamlist',
        name: 'SelTeamList',
        component: () =>
            import ('../views/kqlog/SelTeamList.vue')
    },
    {
        path: '/showworkerlist',
        name: 'ShowWorkerList',
        component: () =>
            import ('../views/kqlog/ShowWorkerList.vue')
    },
    {
        path: '/showWokerInfo',
        name: 'ShowWokerInfo',
        component: () =>
            import ('../views/kqlog/ShowWokerInfo.vue')
    },
    {
        path: '/loginout',
        name: 'LoginOut',
        component: () =>
            import ('../views/setting/LoginOut.vue')
    },
    {
        path: '/workers',
        name: 'Workers',
        component: () =>
            import ('../views/worker/Workers.vue')
    },
    {
        path: '/SelWorkerTeam',
        name: 'SelWorkerTeam',
        component: () =>
            import ('../views/worker/SelWorkerTeam.vue')
    },
    {
        path: '/SelWorkerList',
        name: 'SelWorkerList',
        component: () =>
            import ('../views/worker/SelWorkerList.vue')
    },
    {
        path: '/WorkerInfo',
        name: 'WorkerInfo',
        component: () =>
            import ('../views/worker/WorkerInfo.vue')
    },
    {
        path: '/TeamInfo',
        name: 'TeamInfo',
        component: () =>
            import ('../views/worker/TeamInfo.vue')
    },
    {
        path: "*", 
        redirect: "/"
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router